import React from 'react';
import clsx from 'clsx';

import './FullScreenLayout.css';

//
// --- Types ---

export interface FullScreenLayoutProps {
  children: React.ReactNode;
  className?: string;
}

//
// --- FullScreenLayout Component ---

const FullScreenLayout: React.FC<FullScreenLayoutProps> = props => {
  const { children, className } = props;

  return (
    <div className={clsx('full-screen-layout', className)} data-testid="full-screen-layout">
      {children}
    </div>
  );
};

export default FullScreenLayout;
